import { render, staticRenderFns } from "./Otn.vue?vue&type=template&id=02df4b08&scoped=true&"
import script from "./Otn.vue?vue&type=script&lang=js&"
export * from "./Otn.vue?vue&type=script&lang=js&"
import style0 from "./Otn.vue?vue&type=style&index=0&id=02df4b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df4b08",
  null
  
)

export default component.exports